(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5860],{

/***/ 6699:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-center",
      function () {
        return __webpack_require__(195);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ SearchPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var interweave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9996);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9536);
/* harmony import */ var _layout_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3981);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4850);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1914);








var __N_SSG = true;
function SearchPage(param) {
    var header = param.header, hotelBrands = param.hotelBrands, sitemapData = param.sitemapData;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var ref, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "Offers Help Center | Parador Hotels & Resorts"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                        as: "h1",
                        mb: 6,
                        textAlign: "center",
                        children: locale === "id" ? "Pusat Bantuan" : "Help Center"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(interweave__WEBPACK_IMPORTED_MODULE_2__/* .Markup */ .Lu, {
                        className: "white-space-enter",
                        content: locale == "id" ? (ref = sitemapData.content_id.replace(/\\n/g, "<br>")) !== null && ref !== void 0 ? ref : "" : (ref1 = sitemapData.content_en.replace(/\\n/g, "<br>")) !== null && ref1 !== void 0 ? ref1 : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                h: 10
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                loc: header.location_url,
                address: header.location_long,
                email: header.email,
                phone: header.phone
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,9996,4939,3981,9774,2888,179], function() { return __webpack_exec__(6699); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);